const initTenant = {
  tenants: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  isFormLoading: false,
  tenantsFilter: [],
};

export const tenantReducer = (state = initTenant, action: any) => {
  if (action.type === "SET_TENANT") {
    return {
      ...state,
      tenants: action.value,
    };
  }
  if (action.type === "SET_TENANT_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_TENANT_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  if (action.type === "SET_TENANT_FILTER") {
    return {
      ...state,
      tenantsFilter: action.value,
    };
  }
  return state;
};
